import { render, staticRenderFns } from "./LvArticleContent.vue?vue&type=template&id=c519fbec"
import script from "./LvArticleContent.vue?vue&type=script&lang=js"
export * from "./LvArticleContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports